import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';

import { Form, Input, Modal, Spin } from 'antd';
import { FooterButton } from 'fennec-ui';

var _ = require('lodash');

const ConfirmKeyModal = (props) => {
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const { container, pass, title, content, okText, cancelText, onOk, onCancel } = props;
  const [form] = Form.useForm()

  React.useEffect(() => {
    if (form) {
      form.resetFields();
    }
  });

  const hideModal = () => {
    onCancel();
    setOpen(false);
  };

  React.useEffect(() => {
    return () => {
      setTimeout(function () {
        container.unmount();
      });
    };
  }, [open]);

  const action = (values) => {
    if (values.pass === pass) {
      let res = onOk();
      if (res && _.isFunction(res.then)) {
        setLoading(true)
        res.then(() => {
          setLoading(false)
          setOpen(false);
        })
      } else {
        setOpen(false);
      }
    }
  }
  const footer = () => {
    return [
      FooterButton({
        key: "dismiss",
        name: cancelText || 'Закрыть',
        callback: hideModal,
        options: {
          type: "ghost",
          disabled: loading
        },
        isDesktopOrLaptop: true
      }),
      FooterButton({
        key: "ok",
        name: okText || 'Отправить',
        callback: form.submit,
        options: {
          type: "primary",
          disabled: loading
        },
        isDesktopOrLaptop: true
      })
    ]
  }
  const validator = (func, message) => ({
    validator: (_, value) => {
      if (func(value)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(message))
    }
  });
  return (
    <div>
      <Modal
        title={title}
        open={open}
        onCancel={hideModal}
        closable={true}
        destroyOnClose={true}
        keyboard={false}
        footer={footer()}
      >
        <Spin size="large" spinning={loading}>
          <div>
            <div>
              {content}
            </div>
            <div style={{ marginTop: "10px" }}>
              <Form
                form={form}
                onFinish={action}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                  pass: "",
                }}
              >
                <Form.Item
                  key="pass"
                  name="pass"
                  label={`Введите код подтверждения: ${pass}`}
                  rules={[validator((value) => value === pass, `Неправильно указан код подтверждения`)]}
                >
                  <Input />
                </Form.Item>
              </Form>
            </div>
          </div>
        </Spin>
      </Modal>
    </div >
  );
};

export default function confirmKey(props) {
  var div = document.createElement('div');
  const root = createRoot(div);
  setTimeout(function () {
    root.render(<ConfirmKeyModal container={root} {...props} pass={props.pass || "123"} />);
  });
}

